module.exports = __webpack_public_path__ + "img/solo.web@3x.2df784db.png";